import React, {useState} from 'react';
import {
  Box,
  Flex,
  Input,
  IconButton,
  Tag,
  TagLabel,
  TagCloseButton,
  Tooltip,
} from '@chakra-ui/react';
import {ConfigFormLabel} from './ConfigFormLabel';
import {Information, Add} from '@carbon/icons-react';

export const KeywordsInput = ({
  keywords,
  onChange,
  isDisabled,
  label,
  tooltipLabel,
  placeholder,
}: {
  isDisabled?: boolean;
  keywords?: string[];
  onChange: (keywords: string[]) => void;
  label: string;
  tooltipLabel: string;
  placeholder: string;
}) => {
  const [inputValue, setInputValue] = useState('');

  const trimmedValue = inputValue.trim();
  const canEdit =
    !isDisabled && trimmedValue && !keywords?.includes(trimmedValue);
  const handleAddKeyword = () => {
    if (canEdit) {
      onChange([...(keywords ?? []), trimmedValue]);
      setInputValue('');
    }
  };

  const handleRemoveKeyword = (keywordToRemove: string) => {
    onChange((keywords ?? []).filter((keyword) => keyword !== keywordToRemove));
  };

  return (
    <Box my={1}>
      <ConfigFormLabel>
        <Flex align="center" gap={2}>
          {label}
          <Tooltip label={tooltipLabel} placement="right" hasArrow>
            <Information size={16} />
          </Tooltip>
        </Flex>
      </ConfigFormLabel>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleAddKeyword();
        }}
      >
        <Flex direction="column" gap="3" mt={3}>
          <Flex gap="2">
            <Input
              isDisabled={isDisabled}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder={placeholder}
              fontSize="md"
              size="md"
            />
            <IconButton
              type="submit"
              aria-label="Add keyword"
              icon={<Add size={16} />}
              size="md"
              colorScheme="kbuttonblue"
              isDisabled={!canEdit}
            />
          </Flex>

          {!!keywords?.length && (
            <Flex wrap="wrap" gap="2">
              {keywords.map((keyword) => (
                <Tag
                  key={keyword}
                  size="md"
                  variant="solid"
                  bgColor="kgray.200"
                  color="kgray.400"
                  fontWeight="normal"
                  py={1}
                  pl={3}
                >
                  <TagLabel>{keyword}</TagLabel>
                  <TagCloseButton
                    onClick={() => handleRemoveKeyword(keyword)}
                    isDisabled={isDisabled}
                  />
                </Tag>
              ))}
            </Flex>
          )}
        </Flex>
      </form>
    </Box>
  );
};
